import {FormikValues, useFormikContext} from 'formik'
import React from 'react'

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  name: string
  label?: string
}

const Checkbox = (props: CheckboxProps) => {
  const {className = '', name, label, ...rest} = props
  const {values, handleChange, handleBlur, errors, touched} = useFormikContext<FormikValues>()

  const typedValues = values as Record<string, any>

  return (
    <>
    <div className="d-flex">
      <input
        type='checkbox'
        id={name}
        className={`form-check-input cursor-pointer ${className}}`}
        name={name}
        checked={typedValues[name]}
        onChange={handleChange}
        onBlur={handleBlur}
        {...rest}
      />
      {label && <div className='fw-bold flex-grow-1 ms-1'><label htmlFor={name}>{label}</label></div>}
    </div>

      {touched[name] && errors[name] && (
        <div className="text-danger mt-1 fw-bold" style={{ fontSize: '0.9em' }}>
          {errors[name] as any}
        </div>
      )}
    </>
  )
}

export default Checkbox
